"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Password Recover Form
 * Handles the password recovery modal on the account page
 */
function passwordRecoverForm() {
    var recoverForm = document.getElementById("RecoverPasswordForm");
    var openButton = document.getElementById("OpenRecoverForm");
    var closeButton = document.getElementById("CloseRecoverForm");
    var overlay = document.querySelector(".account-recover-form__overlay");
    if (!recoverForm || !openButton) {
        return;
    }
    openButton.addEventListener("click", function () {
        recoverForm.classList.remove("hide");
        recoverForm.style.display = "flex";
        document.body.style.overflow = "hidden";
    });
    var closeModal = function () {
        if (recoverForm) {
            recoverForm.classList.add("hide");
            recoverForm.style.display = "none";
            document.body.style.overflow = "";
        }
    };
    if (closeButton) {
        closeButton.addEventListener("click", closeModal);
    }
    if (overlay) {
        overlay.addEventListener("click", closeModal);
    }
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" &&
            recoverForm.classList.contains("hide") === false) {
            closeModal();
        }
    });
    if (window.location.hash === "#recover") {
        recoverForm.classList.remove("hide");
        recoverForm.style.display = "flex";
        document.body.style.overflow = "hidden";
    }
}
exports.default = passwordRecoverForm;
